import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    margin: '1rem 0',
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0.5rem',
    width: '3rem',
    '&:first-child': {
      width: '2rem',
      paddingLeft: '2.4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  newSaleCell: {
    position: 'relative',
    verticalAlign: 'middle',

    '&:after': {
      position: 'absolute',
      content: '""',
      display: 'block',
      width: '0.8rem',
      height: '100%',
      backgroundColor: colors.green[400],
      top: 0,
      left: '5px',
      borderRadius: '6px 0px 0px 6px',
    },
  },
  buttonCell: {
    width: '3.2rem',
  },
  actionButton: {
    textTransform: 'uppercase',
    padding: 0,
    '&:last-child': {
      marginLeft: 'auto',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
